interface IReleasesIconProps {
  className?: string;
}

/**
 * Price-tag shape with a forward chevron — the operator metaphor is "tag this
 * commit and ship it." The tag points right (the direction of release) and
 * the chevron sits inside the tag body so the icon reads as one motif at
 * tile scale. Monoline, `currentColor`, no fills, designed on the 48×48 grid.
 */
const ReleasesIcon = ({ className }: IReleasesIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* tag body — left edge vertical, right edge points to a notched tip */}
    <path d="M6 12 H28 L42 24 L28 36 H6 Z" />
    {/* hole punched in the tag, near the left edge */}
    <circle cx="13" cy="24" r="2.5" />
    {/* forward chevron inside the tag body, leading into the tip */}
    <path d="M22 18 L30 24 L22 30" />
  </svg>
);

export default ReleasesIcon;
